import { getViewportWidth } from './helper/helper'
(function () {

	const timers = {
		resize: false,
		resizeDelay: 300,
		hover: false,
		hoverDelay: 300
	};

	class Menu {
		constructor() {
			this.elements = {
				toggle: jQuery('.site-header #mega-menu-wrap-max_mega_menu_1 ~ .hpy-menu-toggle'),
				menu: jQuery('.site-header #mega-menu-wrap-max_mega_menu_1'),
				insert: jQuery('.site-header #mega-menu-wrap-max_mega_menu_1 #mega-menu-max_mega_menu_1'),
			}

			this.settings = {
				breakpoint: 1200,
				duration: 0.2
			};

			this.timelines = {
				mobile: {
					menu: undefined,
				}
			}

			jQuery('.site-header .wp-block-navigation.wp-block-mlp-language-menu').clone().insertBefore(this.elements.insert);
			this.setupTimelines();
			this.setupEvents();
		}

		setupTimelines() {

			if (this.elements.menu) {
				this.elements.menu.data('open', false);
				this.timelines.mobile.menu = gsap.timeline({
					paused: true,
					onStart: () => {
						this.elements.menu.data('open', true);
						document.documentElement.style.overflow = "hidden";
					},
					onReverseComplete: () => {
						this.elements.menu.data('open', false);
						document.documentElement.style.overflow = "";
					},
					onUpdate: () => {

						if (this.timelines.mobile.menu.progress() === 0) {
							return;
						}

						if (this.timelines.mobile.menu.progress() > 0.3) {
							this.elements.menu.addClass('open');
						} else {
							this.elements.menu.removeClass('open');
						}
					}
				});
				gsap.set(this.elements.menu, {
					display: 'none'
				});
				this.timelines.mobile.menu.fromTo(this.elements.menu, {
					xPercent: 105,
					display: 'none'
				}, {
					xPercent: 0,
					display: 'block',
					duration: this.settings.duration,
					ease: "power1.in"
				});
			}
		}

		setupEvents() {
			jQuery(this.elements.toggle).on('click', this.toggleMenu.bind(this));
			jQuery(window).on('resize', () => {
				if (!this.isBreakpoint() && this.elements.menu.data('open')) {
					this.closeMenu();
				}
			});
		}

		openMenu() {
			this.timelines.mobile.menu.play();
			let event = new CustomEvent("hpy-menu-open");
			window.dispatchEvent(event);
		}

		closeMenu() {
			this.timelines.mobile.menu.reverse();
			let event = new CustomEvent("hpy-menu-close");
			window.dispatchEvent(event);
		}

		toggleMenu() {
			if (this.timelines.mobile.menu) {
				if (this.elements.menu.data('open')) {
					this.closeMenu();
				} else {
					this.openMenu();
				}
			}
		}

		isBreakpoint() {
			return getViewportWidth() < this.settings.breakpoint;
		}
	}

	new Menu();



}());